"use client";

import { Card, CardContent } from "@/components/ui/card";
import { CircleCheck as CheckCircle, Calendar, Send, Lock } from 'lucide-react';
const features = [{
  id: 1,
  icon: CheckCircle,
  title: "Informasi Resmi & Terverifikasi",
  description: "Berita lengkap melalui proses verifikasi sebelum dipublikasikan."
}, {
  id: 2,
  icon: Calendar,
  title: "Update Berkelanjutan",
  description: "Berita dan agenda diupdate secara berkala dari sumber resmi organisasi."
}, {
  id: 3,
  icon: Send,
  title: "Kirim Kegiatan Anda",
  description: "Bagikan kegiatan organisasi Anda untuk dinformasikan secara luas."
}, {
  id: 4,
  icon: Lock,
  title: "Akses Dokumen Resmi",
  description: "Dokumen penting organisasi disimpan oleh anggota terdaftar."
}];
export default function Feature() {
  return <section id="featureicongrid" className="bg-background py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={feature.id} data-index={i} className="flex flex-col items-center gap-4 border border-border bg-card p-6 text-center shadow-sm hover:shadow-md transition-shadow">
                <div className="flex h-14 w-14 items-center justify-center rounded-lg bg-accent">
                  <Icon className="h-7 w-7 text-primary" />
                </div>
                <CardContent className="px-0">
                  <h3 className="font-default text-base font-semibold text-foreground mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}